var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClientOnly',[_c('Transition',{attrs:{"name":"ucrs-fade"}},[(_vm.show)?_c('div',{staticClass:"ucrs-message",class:`ucrs-message--${_vm.variant}`},[_c('SvgIcon',{class:`ucrs-message__icon ucrs-message__icon--${_vm.size}`,attrs:{"name":_vm.icon,"aria-hidden":"true"}}),_vm._v(" "),_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }